import React from "react";

const Skills = () => {
  return (
    <div id="skills-page">
      <div className="container">
        <div className="paragraph">
          <h1 className="skills-header">Skills</h1>
          <p>
            Hello, I am Alex Harris-Jedamski! I am a motivated and highly
            educated learner stepping into the world of professional web
            development. I am passionate about programming and creating
            high-quality code using the latest technologies.
          </p>
          <p>
            I have experience working with the React framework, JavaScript ES6,
            Express, Axios, SASS and Flexbox, all of which were used to build
            this website.
          </p>
          <p>
            I am loving the process of mastering modern JavaScript ES6 and
            delving into the fantastic React framework! I always design using a
            responsive, mobile-first approach with a focus on ease of access. I
            also have experience working with Bootstrap 4, Adobe Photoshop and
            Adobe Xd.
          </p>
          <p>
            I have an extensive academic background, with a combined Bachelor’s
            degree in business and international studies and a Master’s degree
            in teaching. My exceptional academic performance, where I achieved a
            grade point average of 6.69 across all studies (Australian grading -
            equates to a British 1st), speaks volumes to my ability to learn,
            perform to deadlines, and submit high quality work.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Skills;
